<template>
  <div id="SliderQuestion" class="border-brand-primary">
    <Slider
      v-for="(item, i) in question.sliders"
      :question="item"
      :updateAnswer="updateAnswer"
      :index="i"
      :key="i"
      :defaultOption="answer[item.slider_text]"
    ></Slider>
  </div>
</template>

<script>
import Slider from "./Slider.vue";

export default {
  name: "SliderQuestion",
  props: ["question", "answer", "setAnswer"],
  components: {
    Slider
  },
  methods: {
    updateAnswer(question, answer) {
      this.answer[question.slider_text] = answer;
    }
  }
};
</script>

<style lang="less">
#SliderQuestion {
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .dmh-confirm-container {
    display: flex;
    background-color: white;
    border: 1px solid;
    border-color: inherit;
    border-radius: 8px;
    flex-direction: column;
    font-size: 1.8rem;
    padding: 15px;
    margin-bottom: 20px;

    .dmh-confirm-input {
      font-family: var(--font-regular, "DMSans");
      margin-top: 15px;
      font-size: 2rem;
    }

    select {
      cursor: pointer;
      border: none;
      width: 100%;
    }

    select:focus {
      outline-width: 0;
    }
  }
}
</style>
